<!--
* 组件名 : 卡片
* 开发者 : XJ
*
-->
<template>
    <div
        class="grid-item card-post-img"
        ref="cardPostImg"
        :data-id="cardData.fileId"
    >
        <div
            class="card-post-img-box"
            @mouseenter="operat_show()"
            @mouseleave="operat_hide()"
        >
            <div
                class="image-show"
                :style="
                    `padding-top: ${(cardData.height / cardData.width) * 100}%`
                "
            >
                <div class="is-qualified" v-if="cardData.is_qualified == -1">
                    此图已下架，禁止下载
                </div>
                <v-icon class="play-icon" v-show="cardData.mimeType === 'video'"
                    >mdi-play</v-icon
                >
                <!-- 智能悬浮视频预览容器 -->
                <div v-if="isHovered && cardData.mimeType === 'video'" class="hover-preview-container">
                    <!-- 通道一：原生 Video 播放 -->
                    <video
                        v-if="!useIframeFallback"
                        ref="previewVideo"
                        class="video-preview-player"
                        :src="videoSrc"
                        muted
                        loop
                        playsinline
                        @canplay="onVideoCanPlay"
                        @error="onVideoError"
                    ></video>
                    <!-- 通道二：智能 Google 官方预览 Iframe 自动兜底 -->
                    <iframe
                        v-else
                        class="video-preview-iframe"
                        :src="iframeSrc"
                        frameborder="0"
                        scrolling="no"
                        allow="autoplay"
                    ></iframe>
                    <!-- 加载中状态 -->
                    <div v-if="videoLoading" class="video-loading-spinner">
                        <v-progress-circular indeterminate color="white" size="24" width="2"></v-progress-circular>
                    </div>
                </div>
                <!-- 404 / 403 链接失效自适应明显提示组件 -->
                <div
                    v-if="isLoadFailed"
                    class="fallback-error-container"
                    @click="on_image_click"
                    @contextmenu="on_contextmenu"
                    title="素材链接失效或无权限 (404/403)"
                >
                    <div class="fallback-error-content">
                        <div class="fallback-icon-wrap">
                            <svg class="broken-img-svg" viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                <rect x="3" y="3" width="18" height="18" rx="3.5" stroke-dasharray="3 3"/>
                                <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
                                <path d="M21 15l-5-5L5 21"/>
                                <line x1="2" y1="2" x2="22" y2="22" stroke="#ef4444" stroke-width="2"/>
                            </svg>
                        </div>
                        <div class="fallback-status-badge">
                            <span class="status-pulse-dot"></span>
                            <span>链接失效 404/403</span>
                        </div>
                        <div class="fallback-msg-title">素材暂无法访问</div>
                        <div class="fallback-msg-sub">文件已被移除或权限受限</div>
                    </div>
                </div>

                <!-- 正常缩略图（未失败时呈现） -->
                <template v-else>
                    <img
                        @click="on_image_click"
                        @contextmenu="on_contextmenu"
                        class="factimg"
                        v-if="cardData.mimeType === 'audio'"
                        :src="displayThumbnail"
                        :style="{ width: '128px', height: '128px' }"
                        :loading="index < 16 ? 'eager' : 'lazy'"
                        :fetchpriority="index < 16 ? 'high' : 'low'"
                        decoding="async"
                        @error="onThumbnailError"
                    />
                    <img
                        @click="on_image_click"
                        @contextmenu="on_contextmenu"
                        class="factimg"
                        v-else
                        :src="displayThumbnail"
                        :loading="index < 16 ? 'eager' : 'lazy'"
                        :fetchpriority="index < 16 ? 'high' : 'low'"
                        decoding="async"
                        @error="onThumbnailError"
                    />
                </template>
                <!-- src="https://www.hidden-advent.org/wp-content/uploads/2018/06/神的审判刑罚带领我脱去地位的枷锁tst-480x320.jpg" -->
                <!-- 专业摄影与设计规格微胶囊标签 -->
                <div class="card-format-chips" v-if="metaBadges.length > 0">
                    <span
                        v-for="(badge, bIdx) in metaBadges"
                        :key="bIdx"
                        class="format-chip"
                        :class="badge.type"
                    >
                        <!-- VIDEO 专用微播放器/摄像机图标 -->
                        <svg v-if="badge.type === 'badge-video'" class="chip-svg-icon" viewBox="0 0 16 16" fill="currentColor">
                            <path d="M2.5 3.5A1.5 1.5 0 0 0 1 5v6a1.5 1.5 0 0 0 1.5 1.5h7A1.5 1.5 0 0 0 11 11V9.5l3.15 1.57A.75.75 0 0 0 15 10.4V5.6a.75.75 0 0 0-1.04-.67L11 6.5V5a1.5 1.5 0 0 0-1.5-1.5h-7zm4 3.2 2.5 1.3-2.5 1.3v-2.6z"/>
                        </svg>
                        <!-- 4K 专用晶体光芒图标 -->
                        <svg v-else-if="badge.type === 'badge-4k'" class="chip-svg-icon" viewBox="0 0 16 16" fill="currentColor">
                            <path d="M8 0.5l1.6 4.9 5.1 0.3-4 3.1 1.4 4.9-4.1-2.9-4.1 2.9 1.4-4.9-4-3.1 5.1-0.3L8 0.5z"/>
                        </svg>
                        <!-- HD 专用高清圆环/准心微标 -->
                        <svg v-else-if="badge.type === 'badge-hd'" class="chip-svg-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6">
                            <rect x="1.5" y="2.5" width="13" height="11" rx="2.5"/>
                            <circle cx="8" cy="8" r="2.2" fill="currentColor"/>
                        </svg>
                        <!-- PSD 专用分层微标 -->
                        <svg v-else-if="badge.type === 'badge-psd'" class="chip-svg-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M8 2.2L14 5.2L8 8.2L2 5.2L8 2.2Z"/>
                            <path d="M2 8.7L8 11.7L14 8.7"/>
                            <path d="M2 12.2L8 15.2L14 12.2"/>
                        </svg>
                        <!-- 长图专用画卷纵向微标 -->
                        <svg v-else-if="badge.type === 'badge-portrait'" class="chip-svg-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3.5" y="1.5" width="9" height="13" rx="1.5"/>
                            <path d="M8 4.5v7m-1.8-5.2L8 4.5l1.8 1.8m-3.6 3.4L8 11.5l1.8-1.8"/>
                        </svg>
                        <span class="chip-text">{{ badge.text }}</span>
                    </span>
                </div>
                <transition name="slideAnimate">
                    <div class="item-info" v-if="operatShow">
                        <input
                            type="checkbox"
                            class="form-check-input pos01"
                            ref="formCheckInput"
                            @click="on_check_box"
                            v-if="cardData.is_qualified != -1"
                        />
                        <div class="info-right">
                            <v-btn
                                class="download"
                                small
                                text
                                dark
                                @click="on_download"
                            >
                                <v-icon small>mdi-download</v-icon>
                                <span class="times">{{
                                    cardData.downloads
                                }}</span>
                            </v-btn>
                            <v-btn
                                class="like"
                                x-small
                                text
                                dark
                                @click="on_toggle_likes"
                            >
                                <v-icon small>mdi-thumb-up-outline</v-icon>
                                <span class="times">{{ cardData.likes }}</span>
                            </v-btn>
                            <v-btn
                                class="dislike"
                                x-small
                                text
                                dark
                                @click="on_toggle_dislike"
                            >
                                <v-icon small>mdi-emoticon-sad-outline</v-icon>
                                <span class="times">{{
                                    cardData.dislikes
                                }}</span>
                            </v-btn>
                        </div>
                    </div>
                </transition>
            </div>
            <div class="post-title" @click="on_preview(index)">
                <b>{{ cardData.name }}</b>
            </div>
        </div>
    </div>
</template>

<script>
import { get_api_data } from "@/utils/ajax";
import { download_single } from "@/utils/util";
import { mapState, mapMutations } from "vuex";
export default {
    name: "v-cards",
    props: {
        cardData: {
            type: Object,
            required: true,
            default: {}
        },
        index: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            isSelected: false,
            hasLike: false,
            hasDislike: false,
            operatShow: false,
            isChecked: false,
            // 视频悬浮预览状态变量
            isHovered: false,
            videoSrc: '',
            iframeSrc: '',
            videoLoading: false,
            useIframeFallback: false,
            hoverTimer: null,
            // 视频缩略图过期动态刷新重试标记
            thumbRetried: false,
            // 404/403 缩略图失效标记
            isLoadFailed: false
        };
    },
    computed: {
        ...mapState("global", ["allCardList"]),
        ...mapState("batchOperation", ["selectedCards"]),
        // 响应式规整缩略图，确保即使本地缓存或历史数据带有 =s300/=s220，也 100% 动态升级为高清 =s450
        displayThumbnail() {
            if (!this.cardData || !this.cardData.thumbnail) return '/dist/img/nopic.png';
            let thumb = this.cardData.thumbnail;
            if (/=s\d+$/.test(thumb)) {
                return thumb.replace(/=s\d+$/, '=s450');
            }
            if (thumb.includes('drive.google.com/thumbnail')) {
                return thumb.replace(/sz=w\d+/, 'sz=w450');
            }
            return thumb;
        },
        metaBadges() {
            const badges = [];
            const name = (this.cardData.name || "").toLowerCase();
            const w = parseFloat(this.cardData.width) || 0;
            const h = parseFloat(this.cardData.height) || 0;
            const isVideo = this.cardData.mimeType === "video";

            if (this.cardData.psdId || name.endsWith(".psd")) {
                badges.push({ text: "PSD", type: "badge-psd" });
            }
            if (isVideo) {
                badges.push({ text: "VIDEO", type: "badge-video" });
            }
            if (w >= 3840 || h >= 2160) {
                badges.push({ text: "4K", type: "badge-4k" });
            } else if (w >= 1920 || h >= 1080) {
                badges.push({ text: "HD", type: "badge-hd" });
            }
            // 如果是视频素材，就不要显示长图（用户明确要求）
            if (!isVideo && h > w * 1.5 && w > 0) {
                badges.push({ text: "长图", type: "badge-portrait" });
            }
            return badges;
        },
    },
    watch: {
        // 卡片复用或切换素材时重置缩略图状态
        "cardData.fileId"() {
            this.thumbRetried = false;
            this.isLoadFailed = false;
        }
    },
    mounted() {
        this.$P.$on("download_all_input_checked", fileIds => {
            if (this.cardData.fileId === fileIds) {
                this.operatShow = false;
            }
        });
        window.dataMap = window.dataMap || {};
        window.dataMap[this.cardData.fileId] = this.cardData;
    },
    methods: {
        ...mapMutations("batchOperation", [
            "addSelectedCards",
            "delSelectedCards"
        ]),
        // 缩略图加载失败（如 404/403 等），自适应呈现明显失效提示
        onThumbnailError(e) {
            if (
                this.cardData.mimeType === 'video' &&
                !this.thumbRetried &&
                this.cardData.fileId
            ) {
                this.thumbRetried = true;
                e.target.src = `https://lh3.google.com/u/0/d/${this.cardData.fileId}=s450`;
                return;
            }
            // 404 / 403 异常激活
            this.isLoadFailed = true;
        },
        //  点击喜欢（点赞）
        async on_toggle_likes() {
            if (this.hasDislike) {
                this.on_toggle_dislike();
            }

            this.hasLike ? this.cardData.likes-- : this.cardData.likes++;
            await get_api_data("POST", "materials/like", {
                fileIds: [this.cardData.fileId],
                action: this.hasLike ? "dec" : "inc"
            });
            this.hasLike = !this.hasLike;
            this.allCardList[this.index].likes = this.cardData.likes;
            this.$P.$emit('show_toast', { text: this.hasLike ? "点赞成功！" : "已取消点赞", type: "success" });
        },

        //  点击不喜欢（点踩）
        async on_toggle_dislike() {
            if (this.hasLike) {
                this.on_toggle_likes();
            }
            this.hasDislike
                ? this.cardData.dislikes--
                : this.cardData.dislikes++;
            await get_api_data("POST", "materials/dislike", {
                fileIds: [this.cardData.fileId],
                action: this.hasDislike ? "dec" : "inc"
            });
            this.hasDislike = !this.hasDislike;
            this.allCardList[this.index].dislikes = this.cardData.dislikes;
            this.$P.$emit('show_toast', { text: this.hasDislike ? "已记录反馈" : "已取消反馈", type: "info" });
        },

        //  下载图片
        async on_download() {
            let result = await get_api_data("POST", "materials/downloads", {
                fileIds: [this.cardData.fileId]
            });

            if (result.status === 200) {
                this.cardData.downloads++;
                // download_single(this.cardData.download_url);
                window.open(this.cardData.download_url, "_self");
                this.$P.$emit('show_toast', { text: "开始下载素材...", type: "success" });
                this.allCardList[
                    this.index
                ].downloads = this.cardData.downloads;
            }
        },

        //  图片预览功能（大图）
        on_preview(current) {
            //  如果是信息通知，在新窗口直接打开链接
            // if (this.cardData.mimeType === "application/vnd.google-apps.document") {
            //   window.open(
            //     `https://docs.google.com/document/d/${this.cardData.file_id}/edit`
            //   );
            //   return;
            // }
            this.$emit("ccPreview", current);
        },
        //  鼠标滑过显示操作按钮
        operat_show() {
            this.operatShow = true;
            this.isHovered = true;

            // 针对视频素材执行防抖加载播放
            if (this.cardData.mimeType === 'video') {
                clearTimeout(this.hoverTimer);
                this.hoverTimer = setTimeout(() => {
                    this.videoLoading = true;
                    this.useIframeFallback = false; // 默认尝试原生播放
                    this.videoSrc = this.cardData.download_url;

                    this.$nextTick(() => {
                        const video = this.$refs.previewVideo;
                        if (video) {
                            video.play().catch(err => {
                                console.warn("Video auto-play blocked or failed", err);
                                // 自动进入 iframe 兜底
                                this.switchToIframeFallback();
                            });
                        }
                    });
                }, 300); // 300ms 防抖，防误触
            }
        },

        operat_hide() {
            if (!$(this.$refs.cardPostImg).hasClass("card-selected")) {
                this.operatShow = false;
            }
            this.isHovered = false;

            // 清除定时器，重置视频状态
            clearTimeout(this.hoverTimer);
            this.videoLoading = false;
            this.videoSrc = '';
            this.iframeSrc = '';
            this.useIframeFallback = false;

            this.$nextTick(() => {
                const video = this.$refs.previewVideo;
                if (video) {
                    video.pause();
                    video.currentTime = 0;
                }
            });
        },

        onVideoCanPlay() {
            this.videoLoading = false;
        },

        onVideoError() {
            // 原生 <video> 播放失败，智能切换为谷歌云端官方预览页
            console.log("Direct link play failed, switching to Google Drive official preview iframe...");
            this.switchToIframeFallback();
        },

        switchToIframeFallback() {
            this.useIframeFallback = true;
            this.videoLoading = true;

            // 谷歌官方预览地址，启用自动播放与静音参数
            this.iframeSrc = `https://drive.google.com/file/d/${this.cardData.fileId}/preview?autoplay=1&mute=1`;

            // Iframe 无法精准捕获 canplay，1.5 秒后自动关闭 loading 状态
            setTimeout(() => {
                if (this.isHovered && this.useIframeFallback) {
                    this.videoLoading = false;
                }
            }, 1500);
        },

        //  选中事件
        async on_check_box(ev) {
            let data = {
                download_url: this.cardData.download_url,
                fileId: this.cardData.fileId,
                index: this.index
            };
            if (ev.target.checked) {
                this.$refs.cardPostImg.classList.add("card-selected");
                this.addSelectedCards(data);
            } else {
                this.$refs.cardPostImg.classList.remove("card-selected");
                this.delSelectedCards(data);
            }
        },

        on_image_click(ev) {
            this.$emit('card-click', this.index, ev);

            if (ev.ctrlKey || ev.metaKey) {
                if (this.cardData.is_qualified === -1) {
                    return;
                }

                ev.preventDefault();
                ev.stopPropagation();
                this.toggleSelection();
            } else if (ev.shiftKey) {
                ev.preventDefault();
                ev.stopPropagation();
            } else {
                this.on_preview(this.index);
            }
        },

        // 修复 Ctrl+Click 在某些浏览器中触发 contextmenu 而非 click 的问题
        on_contextmenu(ev) {
            if (ev.ctrlKey || ev.metaKey) {
                if (this.cardData.is_qualified === -1) {
                    ev.preventDefault();
                    return;
                }

                ev.preventDefault();
                ev.stopPropagation();
                this.$emit('card-click', this.index, ev);
                this.toggleSelection();
            }
        },

        toggleSelection() {
            const isSelected = this.$refs.cardPostImg.classList.contains('card-selected');
            const data = {
                download_url: this.cardData.download_url,
                fileId: this.cardData.fileId,
                index: this.index
            };

            if (isSelected) {
                this.$refs.cardPostImg.classList.remove('card-selected');
                if (this.$refs.formCheckInput) {
                    this.$refs.formCheckInput.checked = false;
                }
                this.delSelectedCards(data);
            } else {
                this.$refs.cardPostImg.classList.add('card-selected');
                if (this.$refs.formCheckInput) {
                    this.$refs.formCheckInput.checked = true;
                }
                this.addSelectedCards(data);
                this.operatShow = true;
            }
        }
    }
};
</script>

<style scoped lang="scss">

.card-post-img {
    position: relative;
    &:hover,
    &.card-selected {
        // .item-info {
        //   transform: translateY(0);
        // }
        .mdi-play {
            opacity: 0;
        }
    }
    &.card-selected {
        .card-post-img-box {
            background: #ecfdf5 !important;
            border: 1.5px solid #10b981 !important;
            border-radius: 12px;
            box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.18) !important;
        }
        .image-show {
            box-shadow: none !important;
        }
    }
    .play-icon {
        pointer-events: none;
    }
}
.is-qualified {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 9999;
    background: rgba(15, 41, 34, 0.65);
    backdrop-filter: blur(4px);
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    padding: 15px;
    text-align: center;
    line-height: 24px;
    border-radius: 8px;
}
.isCardActive {
    background: #ecfdf5;
    border: 1.5px solid #10b981 !important;
    border-radius: 12px;
    .image-show {
        position: relative;
        width: calc((100% / 6) - 24px);
        box-shadow: none !important;
        img {
            width: 100%;
        }
    }
}
.image-show {
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .mdi-play {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 24px;
        color: #fff;
        padding: 7px;
        background: rgba(15, 41, 34, 0.58);
        border: 1px solid rgba(255, 255, 255, 0.35);
        backdrop-filter: blur(6px);
        border-radius: 50%;
        z-index: 1;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.22);
    }
}
.item-info {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 12;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    padding: 0 6px 0 8px;
    height: 38px;
    border-radius: 8px 8px 0 0 !important;
    background: linear-gradient(
        180deg,
        rgba(6, 38, 29, 0.82) 0%,
        rgba(6, 38, 29, 0.48) 55%,
        rgba(6, 38, 29, 0) 100%
    );

    .form-check-input {
        width: 17px;
        height: 17px;
        margin: 0;
        flex-shrink: 0;
        accent-color: #10b981;
        cursor: pointer;
        border-radius: 4px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
        transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.2s ease;
        &:hover {
            transform: scale(1.15);
            box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.35);
        }
    }

    .info-right {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        gap: 4px;
        margin-right: 0;
        white-space: nowrap;

        .v-btn {
            min-width: auto !important;
            height: 24px !important;
            padding: 0 6px !important;
            border-radius: 6px !important;
            background: rgba(255, 255, 255, 0.16) !important;
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
            border: 1px solid rgba(255, 255, 255, 0.25) !important;
            transition: all 0.22s cubic-bezier(0.16, 1, 0.3, 1) !important;

            &:hover {
                background: rgba(16, 185, 129, 0.88) !important;
                border-color: rgba(52, 211, 153, 0.8) !important;
                transform: translateY(-1px);
                box-shadow: 0 4px 10px rgba(13, 148, 136, 0.35);
            }

            &:active {
                transform: translateY(0);
            }
        }
        .v-icon {
            font-size: 14px !important;
            color: #ffffff !important;
        }
        .times {
            font-size: 11.5px;
            font-weight: 600;
            color: #ffffff;
            line-height: 1;
            margin-left: 3px;
            letter-spacing: 0.2px;
        }
    }
}
.v-btn:not(.v-btn--round).v-size--small,
.v-btn:not(.v-btn--round).v-size--x-small {
    min-width: auto !important;
    padding: 0 4px !important;
}

.slideAnimate-enter-active,
.slideAnimate-leave-active {
    transition: opacity 0.22s cubic-bezier(0.16, 1, 0.3, 1), transform 0.22s cubic-bezier(0.16, 1, 0.3, 1);
}

.slideAnimate-enter,
.slideAnimate-leave-to {
    opacity: 0;
    transform: translateY(-8px);
}

/* ---- 视频悬浮预览（功能样式） ---- */
.hover-preview-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    background-color: #000;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
    overflow: hidden;
    pointer-events: none; /* 避免阻挡卡片的点击与拖拽操作 */
}

.video-preview-player {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    &[src] {
        opacity: 1;
    }
}

.video-preview-iframe {
    width: 100%;
    height: 120%; /* 稍微拉伸高度，隐藏 Google 播放器顶部标题栏与控制条 */
    margin-top: -10%;
    object-fit: cover;
}

.video-loading-spinner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.4);
    z-index: 11;
}

/* 卡片缩略图平滑展示与交互 */
.card-post-img .factimg {
    opacity: 1;
    transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), filter 0.3s ease !important;
}

/* 专业设计/摄影规格微胶囊徽章（精致毛玻璃与高光内阴影） */
.card-format-chips {
    position: absolute;
    bottom: 8px;
    left: 8px;
    display: flex;
    align-items: center;
    gap: 4.5px;
    z-index: 2;
    pointer-events: none;
    transition: opacity 0.22s ease, transform 0.22s cubic-bezier(0.16, 1, 0.3, 1);

    .format-chip {
        display: inline-flex;
        align-items: center;
        gap: 3.5px;
        height: 20px;
        padding: 0 6.5px;
        border-radius: 5px;
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
        letter-spacing: 0.05em;
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.38), 0 3px 8px rgba(0, 0, 0, 0.28);
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.28);
        user-select: none;

        .chip-svg-icon {
            width: 11px;
            height: 11px;
            flex-shrink: 0;
            display: block;
            filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3));
        }

        .chip-text {
            display: inline-block;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
            transform: translateY(0.5px);
        }

        &.badge-video {
            background: linear-gradient(135deg, rgba(139, 92, 246, 0.9) 0%, rgba(109, 40, 217, 0.95) 100%);
            color: #ffffff;
            border: 0.5px solid rgba(221, 214, 254, 0.5);
            box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.45), 0 3px 10px rgba(109, 40, 217, 0.4);
        }

        &.badge-4k {
            background: linear-gradient(135deg, rgba(245, 158, 11, 0.92) 0%, rgba(217, 119, 6, 0.96) 100%);
            color: #ffffff;
            border: 0.5px solid rgba(254, 240, 138, 0.55);
            box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.45), 0 3px 10px rgba(245, 158, 11, 0.4);
        }

        &.badge-hd {
            background: linear-gradient(135deg, rgba(16, 185, 129, 0.9) 0%, rgba(5, 150, 105, 0.95) 100%);
            color: #ffffff;
            border: 0.5px solid rgba(167, 243, 208, 0.5);
            box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4), 0 3px 10px rgba(16, 185, 129, 0.38);
        }

        &.badge-psd {
            background: linear-gradient(135deg, rgba(14, 165, 233, 0.9) 0%, rgba(2, 132, 199, 0.95) 100%);
            color: #ffffff;
            border: 0.5px solid rgba(186, 230, 253, 0.5);
            box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4), 0 3px 10px rgba(14, 165, 233, 0.38);
        }

        &.badge-portrait {
            background: linear-gradient(135deg, rgba(30, 41, 59, 0.88) 0%, rgba(15, 23, 42, 0.94) 100%);
            color: #f8fafc;
            border: 0.5px solid rgba(255, 255, 255, 0.28);
            box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3), 0 3px 10px rgba(15, 23, 42, 0.4);
        }
    }
}

.card-post-img-box:hover .card-format-chips {
    opacity: 0.95;
    transform: translateY(-2px);
}

/* 404/403 异常状态全尺寸自适应明显提示组件 */
.fallback-error-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 50%, #e2e8f0 100%);
    border-radius: 8px;
    padding: 16px;
    box-sizing: border-box;
    cursor: pointer;
    overflow: hidden;
    user-select: none;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: radial-gradient(rgba(148, 163, 184, 0.22) 1px, transparent 1px);
        background-size: 16px 16px;
        opacity: 0.6;
        pointer-events: none;
    }

    .fallback-error-content {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        max-width: 90%;
    }

    .fallback-icon-wrap {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04);
        margin-bottom: 10px;
        color: #94a3b8;
        border: 1px solid rgba(226, 232, 240, 0.9);
        transition: transform 0.3s ease;
    }

    .fallback-status-badge {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        padding: 3px 9px;
        background: rgba(254, 242, 242, 0.95);
        border: 1px solid rgba(248, 113, 113, 0.35);
        border-radius: 20px;
        font-size: 11px;
        font-weight: 700;
        color: #dc2626;
        margin-bottom: 6px;
        box-shadow: 0 2px 6px rgba(239, 68, 68, 0.12);

        .status-pulse-dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #ef4444;
            box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.25);
            animation: pulse-dot 1.8s infinite;
        }
    }

    .fallback-msg-title {
        font-size: 13px;
        font-weight: 600;
        color: #334155;
        line-height: 1.4;
        margin-bottom: 2px;
    }

    .fallback-msg-sub {
        font-size: 11px;
        color: #94a3b8;
        line-height: 1.3;
    }

    &:hover {
        background: linear-gradient(145deg, #ffffff 0%, #f1f5f9 100%);
        box-shadow: inset 0 0 0 1.5px rgba(239, 68, 68, 0.3);

        .fallback-icon-wrap {
            transform: scale(1.08);
            border-color: rgba(239, 68, 68, 0.3);
        }
    }
}

@keyframes pulse-dot {
    0%, 100% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.3);
        opacity: 0.6;
    }
}
</style>
